import "./chartModal.scss";
import ReactDOM from "react-dom";

import React, { Fragment, useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

const ChartModal = ({ isOpen, onClose, buyPrices, sellPrices }) => {
  const modalRef = useRef(null);
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);


  useEffect(() => {
    if (isOpen) {
      // Destroy the existing chart instance if it exists
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      // Create or update the chart when the modal is opened
      const ctx = chartRef.current.getContext("2d");
      chartInstanceRef.current = new Chart(ctx, {
        type: "line",
        data: {
          labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
          datasets: [
            {
              label: "قیمت خرید",
              data: buyPrices,
              borderColor: "green",
              backgroundColor: "rgba(0, 255, 0, 0.1)",
            },
            {
              label: "قیمت فروش",
              data: sellPrices,
              borderColor: "red",
              backgroundColor: "rgba(255, 0, 0, 0.1)",
            },
          ],
        },
      });
    }
  }, [isOpen, buyPrices, sellPrices]);

  useEffect(() => {
    // Close the modal when clicking outside of it
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  return (
    <Fragment>
      {isOpen &&
        ReactDOM.createPortal(
          <div className={`modal ${isOpen ? "open" : ""}`}>
            <div className="modal-content" ref={modalRef}>
              <canvas ref={chartRef} width="400" height="200" />
            </div>
          </div>,
          document.getElementById("modals")
        )}
    </Fragment>
  );
};

export default ChartModal;
